"use client";

import { LiveQueryProvider } from "@sanity/preview-kit";
import { getClient } from "@marketing-sites/sanity-client";

const previewClient = getClient("intercom-com", true);

export function SanityPreviewTokenProvider({
  children,
  token,
}: {
  children: React.ReactNode;
  token: string;
}) {
  if (!token) {
    throw new Error("Preview token is required for live previews");
  }

  return (
    <LiveQueryProvider client={previewClient} token={token}>
      {children}
    </LiveQueryProvider>
  );
}
